import Client from "../shared/services/Client";

function getProductRatePlanInformationByReferralToken(referralToken: string): Promise<any> { // eslint-disable-line @typescript-eslint/no-explicit-any
    return Client.get(`/api/referrals/${ encodeURIComponent(referralToken) }/rate-plan-info`);
}

const Token = {
    getProductRatePlanInformationByReferralToken
};

export default Token;
